<template>
  <header class="bg-primary-500 h-[96px] sm:h-[102px] sticky top-0 z-20">
    <div
      :class="isAuthenticated ? 'justify-between' : 'justify-center'"
      class="flex items-center h-full px-6 weiby-container sm:pt-8"
    >
      <w-button
        v-if="isAuthenticated"
        class="flex-grow-0 flex-shrink-0 mr-6 sm:mr-0 text-4xl weiby-header__menu--btn sm:text-2xl"
        id="open-menu"
        variant="icon"
        @click="$emit('show-menu')"
      >
        <i v-show="menuOpened" class="icon-double-left" />
        <section v-show="!menuOpened">
          <i class="icon-double-right" />
          <i class="icon-menu" />
        </section>
      </w-button>
      <div
        :class="{ 'sm:items-start': !isAuthenticated && showCartButton }"
        class="
          flex
          flex-grow
          items-center
          justify-start
          sm:flex-col
          sm:justify-center
          truncate
        "
      >
        <router-link :to="isAuthenticated ? '/menu' : '/login'">
          <img
            alt="Logo"
            class="h-[38px] sm:h-[24px] sm:mb-1"
            src="/logo-white.svg"
          />
        </router-link>
        <h1
          v-if="tempCompany || (isAuthenticated && company)"
          :title="tempCompany || company"
          class="
            -translate-x-1/2
            -translate-y-1/2
            absolute
            left-1/2
            max-w-full
            px-4
            sm:flex-grow
            sm:font-light
            sm:ml-0
            sm:static
            sm:text-lg
            sm:translate-x-0
            sm:translate-y-0
            text-white
            text-3xl
            top-1/2
            transform
            truncate
          "
        >
          {{ tempCompany || company }}
        </h1>
      </div>
      <section class="relative">
        <w-button
          v-if="showCartButton"
          class="flex flex-grow-0 flex-shrink-0 items-center text-2xl"
          id="open-cart"
          variant="icon"
          @click="$emit('show-cart')"
        >
          <i
            :class="{ 'text-3xl': !$breakpoints.sm }"
            class="mr-0.5 icon-shopping-cart"
          />
          <span
            v-if="cartItemsCount"
            class="
              bg-white
              px-3
              rounded-[16px]
              sm:text-lg
              text-primary-500
            "
          >
            {{ cartItemsCount }}
          </span>
        </w-button>
        <div v-if="showItem" class="z-30">
          <div class="
            absolute
            bg-white
            border
            border-secondary-100
            default-card-border
            h-[20px]
            rotate-45
            rounded-sm
            top-12
            w-[20px]
          " />
          <div class="
            absolute
            bg-white
            border
            border-secondary-100
            default-card-border
            flex
            justify-between
            px-6
            py-4
            right-0
            rounded
            top-14
            w-[312px]
          ">
            <span class="mr-6">{{ itemInfos.count }}X</span>
            <div class="line-clamp-2">
              <label class="line-clamp-2">{{ itemInfos.name }}</label>
              <p v-if="itemInfos.note" class="line-clamp-2 mt-2 text-gray-500 text-sm">
                {{ itemInfos.note }}
              </p>
            </div>
            <span class="ml-4">{{ itemInfos.price | commaFormat | priceFormat }}</span>
          </div>
        </div>
      </section>
    </div>
  </header>
</template>

<script>
import Header from './Header';

export default Header;
</script>

<style lang="scss" scoped>
@import 'Header';
</style>
